"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var functions_1 = require("@firsttable/functions");
var useFacebookLoading = function () {
    var _a = (0, react_1.useState)(false), loaded = _a[0], setLoaded = _a[1];
    var initializeFacebookSDK = function () {
        if (!functions_1.isBrowser) {
            return null;
        }
        window.fbAsyncInit = function () {
            FB.init({
                appId: process.env.GATSBY_FACEBOOK_ID,
                cookie: true,
                version: 'v6.0',
            });
            setLoaded(true);
        };
        // Load the SDK asynchronously
        // eslint-disable-next-line func-names
        (function (d, s, id) {
            var js;
            var fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id))
                return;
            // eslint-disable-next-line prefer-const
            js = d.createElement(s);
            js.id = id;
            js.src = '//connect.facebook.net/en_US/sdk.js';
            fjs.parentNode.insertBefore(js, fjs);
        })(document, 'script', 'facebook-jssdk');
    };
    (0, react_1.useEffect)(function () {
        initializeFacebookSDK();
    }, []);
    return loaded;
};
exports.default = useFacebookLoading;
//# sourceMappingURL=facebook.js.map